module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [(_vm.finished) ? _c('div', [_c('h2', [_vm._v("Your request has been sent. We will be in touch shortly.")]), _vm._v(" "), _c('v-btn', {
    staticClass: "cursor",
    attrs: {
      "color": "primary"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.onLogout($event)
      }
    }
  }, [_vm._v("Log Out")])], 1) : _vm._e(), _vm._v(" "), (!_vm.finished) ? _c('v-stepper', {
    staticClass: "pfStepper",
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.step),
      callback: function($$v) {
        _vm.step = $$v
      },
      expression: "step"
    }
  }, [_c('h3', {
    staticClass: "issueH"
  }, [_vm._v("Issue: " + _vm._s(_vm.$route.params.type))]), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "1",
      "complete": _vm.step > 1
    }
  }, [_vm._v("\n          About the Issue\n           "), _c('small', [_vm._v("Please provide as much information as possible")])]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "1"
    }
  }, [_c('v-form', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "data-vv-scope": "form-1"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": "Is your issue related to an appliance?"
    },
    model: {
      value: (_vm.switchApp),
      callback: function($$v) {
        _vm.switchApp = $$v
      },
      expression: "switchApp"
    }
  })], 1)], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.switchApp) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "eg TV, Boiler etc",
      "label": "Type of appliance",
      "error-messages": _vm.errors.collect('applianceType'),
      "data-vv-name": "applianceType",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.applianceType),
      callback: function($$v) {
        _vm.applianceType = $$v
      },
      expression: "applianceType"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.switchApp) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "label": "Appliance Make",
      "error-messages": _vm.errors.collect('applianceMake'),
      "data-vv-name": "applianceMake",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.applianceMake),
      callback: function($$v) {
        _vm.applianceMake = $$v
      },
      expression: "applianceMake"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.switchApp) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "If you can see a serial number, what is it?",
      "label": "Appliance serial number",
      "error-messages": _vm.errors.collect('applianceSerial'),
      "data-vv-name": "applianceSerial",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.applianceSerial),
      callback: function($$v) {
        _vm.applianceSerial = $$v
      },
      expression: "applianceSerial"
    }
  })], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:3000'),
      expression: "'required|max:3000'"
    }],
    attrs: {
      "box": "",
      "label": "Description of repair / issue",
      "hint": "Please describe the issue in as much detail as possible",
      "error-messages": _vm.errors.collect('issueText'),
      "auto-grow": "",
      "data-vv-name": "issueText",
      "required": "",
      "data-vv-scope": "form-1"
    },
    model: {
      value: (_vm.issueText),
      callback: function($$v) {
        _vm.issueText = $$v
      },
      expression: "issueText"
    }
  })], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitForm('form-1')
      }
    }
  }, [_vm._v("Continue")])], 1)], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "2",
      "complete": _vm.step > 2
    }
  }, [_vm._v("Upload an photo")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "2"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "component-fade",
      "appear": ""
    }
  }, [(_vm.imageUrl) ? _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('img', {
    staticStyle: {
      "height": "150px"
    },
    attrs: {
      "src": _vm.imageUrl
    }
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "raised": ""
    },
    on: {
      "click": _vm.onPickFile
    }
  }, [_vm._v("Upload Image")])], 1)], 1), _vm._v(" "), _c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*"
    },
    on: {
      "change": _vm.onFilePicked
    }
  }), _vm._v(" "), (_vm.showProgress) ? _c('v-progress-linear', {
    model: {
      value: (_vm.progressUpload),
      callback: function($$v) {
        _vm.progressUpload = $$v
      },
      expression: "progressUpload"
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        _vm.step = 3
      }
    }
  }, [_vm._v("Continue")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("Go Back")])], 1), _vm._v(" "), _c('v-stepper-step', {
    attrs: {
      "step": "3",
      "complete": _vm.step > 3
    }
  }, [_vm._v("Contact details and consent")]), _vm._v(" "), _c('v-stepper-content', {
    attrs: {
      "step": "3"
    }
  }, [_c('v-form', {
    staticStyle: {
      "padding": "10px"
    },
    attrs: {
      "data-vv-scope": "form-3"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:60'),
      expression: "'required|max:60'"
    }],
    attrs: {
      "box": "",
      "label": "Contact Name",
      "error-messages": _vm.errors.collect('contactName'),
      "data-vv-name": "applianceType",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.contactName),
      callback: function($$v) {
        _vm.contactName = $$v
      },
      expression: "contactName"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:30'),
      expression: "'required|max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "What is the best telephone number to contact you on?",
      "label": "Telephone Number",
      "error-messages": _vm.errors.collect('tel'),
      "data-vv-name": "tel",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.tel),
      callback: function($$v) {
        _vm.tel = $$v
      },
      expression: "tel"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "hint": "What is an alternative number to contact you on?",
      "label": "Additional Number",
      "error-messages": _vm.errors.collect('tel2'),
      "data-vv-name": "tel2",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.tel2),
      callback: function($$v) {
        _vm.tel2 = $$v
      },
      expression: "tel2"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('max:30'),
      expression: "'max:30'"
    }],
    attrs: {
      "box": "",
      "label": "Access times available / arrangements",
      "hint": "Please give a good day and time for the repair work to be carried out",
      "error-messages": _vm.errors.collect('dayTime'),
      "data-vv-name": "dayTime",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.dayTime),
      callback: function($$v) {
        _vm.dayTime = $$v
      },
      expression: "dayTime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-checkbox', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "I give permission for third party contrators to access the property using management keys. ",
      "error-messages": _vm.errors.collect('permission'),
      "data-vv-name": "permission",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.permission),
      callback: function($$v) {
        _vm.permission = $$v
      },
      expression: "permission"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('v-checkbox', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "label": "I consent to my personal details being passed on to third party contrators to complete the repair work.",
      "error-messages": _vm.errors.collect('consent'),
      "data-vv-name": "consent",
      "required": "",
      "data-vv-scope": "form-3"
    },
    model: {
      value: (_vm.consent),
      callback: function($$v) {
        _vm.consent = $$v
      },
      expression: "consent"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.loading) ? _c('v-btn', {
    attrs: {
      "color": "primary",
      "ripple": "",
      "disabled": _vm.loading
    },
    nativeOn: {
      "click": function($event) {
        _vm.submitForm('form-3')
      }
    }
  }, [_vm._v("Send Request")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.goBack($event)
      }
    }
  }, [_vm._v("Go Back")])], 1)], 1), _vm._v(" "), (_vm.loading) ? _c('v-progress-linear', {
    attrs: {
      "indeterminate": true
    }
  }) : _vm._e()], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f7fda6a0","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/IssueRequest.vue
// module id = 362
// module chunks = 4